<div *ngIf="applySsnMasker; else phoneFormatTemplate">

<!-- Input with SSN Masker Directive -->
<label [for]="label">{{ label }}</label>
<input
[id]="id"
pInputText
[type]="type"
[(ngModel)]="value"
(ngModelChange)="onValueChange($event)"
[disabled]="disabled"
[placeholder]="placeholder"
[maxlength]="maxlength"
[ngClass]="customClass"
[required]="isrequired"
ngModel #inputControl="ngModel"
appSsnMasker
[style]="{'width': '90%'}"
/>
<div *ngIf="inputControl?.invalid && inputControl?.touched" class="text-danger">
{{ inputlabel }} is required.
</div>
</div>

<ng-template #phoneFormatTemplate>
<div *ngIf="appPhoneFormat; else maskFormatTemplate">

<!-- Input with Phone Format Directive -->
<label [for]="label">{{ label }}</label>
<input
[id]="id"
pInputText
type="text"
[(ngModel)]="value"
(ngModelChange)="onValueChange($event)"
[disabled]="disabled"
[placeholder]="placeholder"
[maxlength]="maxlength"
[ngClass]="customClass"
[required]="isrequired"
ngModel #inputControl="ngModel"
appPhoneFormat
/>
<div *ngIf="inputControl?.invalid && inputControl?.touched" class="text-danger">
{{ inputlabel }} is required.
</div>
</div>

<ng-template #maskFormatTemplate>
<div *ngIf="maskFormat; else noMask">

<!-- Input with Phone Format Directive -->
<label [for]="label">{{ label }}</label>
<input
[id]="id"
pInputText
type="text"
[(ngModel)]="value"
(ngModelChange)="onValueChange($event)"
[disabled]="disabled"
[placeholder]="placeholder"
[maxlength]="maxlength"
[ngClass]="customClass"
[required]="isrequired"
ngModel #inputControl="ngModel"
appMasker
/>
<div *ngIf="inputControl?.invalid && inputControl?.touched" class="text-danger">
{{ inputlabel }} is required.
</div>
</div>

<ng-template #noMask>

<!-- Input without any mask -->
<label [for]="label">{{ label }}</label>
<input
[id]="id"
pInputText
type="text"
[(ngModel)]="value"
(ngModelChange)="onValueChange($event)"
[disabled]="disabled"
[placeholder]="placeholder"
[maxlength]="maxlength"
[ngClass]="customClass"
[required]="isrequired"
ngModel
#inputControl="ngModel"
/>
<div *ngIf="inputControl?.invalid && inputControl?.touched" class="text-danger">
{{ inputlabel }} is required.
</div>
</ng-template>
</ng-template>